import CryptoJS from 'crypto-js';
import EnvConfig from 'env.config';

export function getStorageKey() {
  const key = sessionStorage.getItem(EnvConfig.firstTokenName);
  if (!key) {
    return sessionStorage.getItem(EnvConfig.tokenName);
  }
  return key;
}

// eslint-disable-next-line import/prefer-default-export
export function getStorageSetting(option) {
  const key = getStorageKey();
  if (!key) {
    return null;
  }

  const options = sessionStorage.getItem(EnvConfig.optionsName);
  if (!options) {
    return null;
  }
  const decryptedArray = CryptoJS.AES.decrypt(options, key.substring(64, 96));
  const decryptedText = decryptedArray.toString(CryptoJS.enc.Utf8);
  const jsonObject = JSON.parse(decryptedText);

  if (option === 'settings' || !option) {
    delete jsonObject.permissions;
    return jsonObject;
  }
  return jsonObject[option];
}
